const SET_COUNTRIES = (state, countries) => {
  state.countries = countries
}

export default {
  SET_COUNTRIES
}



// WEBPACK FOOTER //
// ./src/store/modules/countries/mutations.js